export const BATTLE_PHASES = [
  'PRE_BATTLE', 'FIGHTING', 'SUPER_CINEMATIC', 'ROUND_END', 'FINISHED',
] as const;

export type BattlePhase = (typeof BATTLE_PHASES)[number];

const LEGAL_TRANSITIONS: Readonly<Record<BattlePhase, readonly BattlePhase[]>> = {
  PRE_BATTLE: ['FIGHTING', 'FINISHED'],
  FIGHTING: ['SUPER_CINEMATIC', 'ROUND_END', 'FINISHED'],
  SUPER_CINEMATIC: ['FIGHTING', 'ROUND_END', 'FINISHED'],
  ROUND_END: ['FINISHED'],
  FINISHED: [],
};

export const isBattlePhase = (value: unknown): value is BattlePhase =>
  typeof value === 'string' && (BATTLE_PHASES as readonly string[]).includes(value);

export const canTransitionBattlePhase = (from: BattlePhase, to: BattlePhase): boolean =>
  from === to || LEGAL_TRANSITIONS[from].includes(to);
